/* eslint-disable import/prefer-default-export */

import { SEG_VIEW } from 'src/store/ActionTypes';

export const fetchEntity = (entity, id) => ({
  type: SEG_VIEW.FETCH_ENTITY,
  payload: {
    id,
    entity,
  },
});

export const editEntity = (entity, id, payload) => ({
  type: SEG_VIEW.EDIT_ENTITY,
  payload: {
    id,
    entity,
    payload,
  },
});
